import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Route, Switch, useHistory } from "react-router-dom";
import Page404 from "go-app/components/Page404/Page404";
import { selectIsAdmin, selectUser } from "go-security/services/users/selectors";
import { AdminClientDetailsIndexPage } from "./pages/ClientDetails";
import { ProductPackagesPage } from "./pages/ProductPackages";
import AdminTenantsPage from "./pages/Tenant";

const AdminPage = (props: RouteComponentProps) => {
	const isAdmin = useSelector(selectIsAdmin);
	const user = useSelector(selectUser);
	const isSupport = user.roles?.includes("ROLE_SUPPORT");
	const history = useHistory();

	useEffect(() => {
		if (!isAdmin && !isSupport) {
			history.replace("/");
		}
	}, []);

	return (
		<div className="page-container">
			<div className="content">
				<Switch>
					{isAdmin && <Route path={`${props.match.url}/tenants`} component={AdminTenantsPage} />}
					{isAdmin && (
						<Route path={`${props.match.url}/client_details`} component={AdminClientDetailsIndexPage} />
					)}
					{(isAdmin || isSupport) && (
						<Route path={`${props.match.url}/product_packages`} component={ProductPackagesPage} />
					)}
					<Page404 />
				</Switch>
			</div>
		</div>
	);
};

export default AdminPage;
